import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import Schedule from '../common/Schedule';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import SortBy from '../Results/SortBy';
import PageLoader from '../common/PageLoader';
import { size } from 'lodash';
import { each, map, sumBy, indexOf, range } from 'lodash';
import { imageBasePath, appBasePath } from '../../constants/staticData';
import { timeSince } from '../../helpers';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class EmergencyList extends Component {
    constructor(props, context) {
        super(props, context);
        this.toggleNotification = this.toggleNotification.bind(this);
        this.state = {
            searchMobile: false,
            notificationVisible: false,
            showSidebar: false,
            isChatRoomsLoaded: props.commonReducer.isChatRoomsLoaded ? true : false
        };
    }
    componentWillMount() {
        this.props.actions.getEmergencyList();
        const authData = JSON.parse(localStorage.businessAuthData);
        if (!this.props.commonReducer.isChatRoomsLoaded) {
            this.props.actions.getAllChatRooms(authData.garageId);
        }
        // document.body.addEventListener('mousedown', this.bodyClick.bind(this));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.commonReducer.isChatRoomsLoaded && !this.state.isChatRoomsLoaded) {
            this.setState({ isChatRoomsLoaded: true });
        }
    }
    toggleNotification(isVisible) {
        this.setState({ notificationVisible: isVisible });
    }
    hclickCallBack() {
        this.setState({ showSidebar: !this.state.showSidebar });
    }
    bodyClick(e) {
        if (e.target.closest('.sidebar') == null) {
            this.setState({ showSidebar: false });
        }
    }

    render() {
        const {
            commonReducer,
            actions
        } = this.props;
        let allNotification = [];
        if (commonReducer.emergencyList && commonReducer.emergencyList.length) {
          allNotification = commonReducer.emergencyList.filter((eachNotification) => {
            return eachNotification && eachNotification.bookingId.includes('EMG');
          })
          console.log("EMG notification = ", allNotification);
        }
        let notificationsData = allNotification;
        // let notificationsData = this.props.commonReducer.emergencyList;
        const services = {
            1: 'wash',
            2: 'repair',
            3: 'service',
            4: 'emergency service'
        };
        //{`${message.vehicle_model} : ${message.service_name}`}
        const EmergencyList = map(notificationsData, (message, key) => {
            return (
                <div
                    key={key}
                    className={'alert-card alert-card-list ' + services[4]}
                    onClick={e => {
                        e.preventDefault();
                        this.props.router.push(`${appBasePath}/job/${message.requestId}`);
                    }}
                >
                    <span className={'alert-color ' + services[4]} />
                    <h5 className="alert-text">
                        {' '}
                        {`${message.type}`}
                        <span className="duration-text">{timeSince(new Date(message.created_at))} Ago</span>
                    </h5>

                    {/*message.urgent && <i className="mdi mdi-timer-sand" />*/}
                </div>
            );
        });
        return (
            <div>
                {/*Header*/}
                <Header
                    searchMobile={this.state.searchMobile}
                    hideOption={() => this.setState({ searchMobile: true })}
                    notificationCount={2}
                    commonReducer={this.props.commonReducer}
                    actions={this.props.actions}
                    profileName="Derrick Frank"
                    notificationCallBack={this.toggleNotification}
                    authReducer={this.props.authReducer}
                    hCallback={() => {
                        this.hclickCallBack();
                    }}
                    router={this.props.router}
                />
                <MobileNotification
                    isVisible={this.state.notificationVisible}
                    backBtnCallBack={this.toggleNotification}
                />
                <div className="main-wrapper">
                    {/*Sidebar*/}
                    <Sidebar
                        showSidebar={this.state.showSidebar}
                        router={this.props.router}
                        actions={this.props.actions}
                        commonReducer={this.props.commonReducer}
                        authReducer={this.props.authReducer}
                    />
                    <div className="container-fluid main-container">
                        <div className="col-md-9 mpad0 padr30">
                            <div className="overview-heading">
                                <h5>
                                    EmergencyList
                                    {' '}
                                    {this.props.commonReducer.emergencyList.length > 0
                                        ? `(${size(allNotification)} )`
                                        : ''}
                                </h5>
                            </div>
                            <div className="content-view">
                                <div>
                                    {this.props.commonReducer.emergencyList.length > 0 && EmergencyList}

                                    {this.props.commonReducer.emergencyList.length == 0 &&
                                        <div className="empty-state-holder">
                                            <span className="empty-state-content">
                                                <img src={`${imageBasePath}/no_jobs.png`} />
                                                <span>Looks like there is no Emergency request. </span>
                                            </span>
                                        </div>}
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mpad0 padLeft0">
                            <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
                        </div>
                    </div>
                </div>
                {this.state.searchMobile &&
                    <div>

                        <MobileHeaderSearch
                            mobile={true}
                            actions={this.props.actions}
                            commonReducer={this.props.commonReducer}
                            mobSearchClick={() => this.setState({ searchMobile: false })}
                        />
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/emergencyServices/EmergencyList.jsx